// extracted by mini-css-extract-plugin
export var logo = "_jl-2";
export var logoWrapper = "_jl-1";
export var strip = "_jl-0";